import { InMemoryCache } from '@apollo/client';
import { browserHttpLink } from '@seek/ca-graphql-client/browser';
import { createHead, UnheadProvider } from '@unhead/react/client';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { loadableReady } from 'sku/@loadable/component';
import Cookies from 'universal-cookie';

import { HubbleClientProvider } from 'src/App/providers/HubbleClientProvider';
import { MelwaysClientProvider } from 'src/App/providers/MelwaysClientProvider';

import { App } from '../App/App';
import { configureApolloClient } from '../sharedUtils/configureApolloClient';

loadableReady(() => {
  const config = window.__CONFIG__;
  const { appName, brand, country, environment, site } = config;

  const cookies = new Cookies(null, { path: '/' });

  const authToken =
    environment === 'development' ? cookies.get<string>('TEST_AUTH_TOKEN') : '';

  const apolloClient = configureApolloClient({
    appName,
    brand,
    country,
    httpLink: browserHttpLink,
    environment,
    cache: new InMemoryCache().restore(window.__APOLLO_STATE__ || {}),
    ssrMode: false,
    headers: {
      ...(authToken ? { authorization: `Bearer ${authToken}` } : {}),
    },
    // Note: For non-dev client. the authToken is automatically set from browser cookie to apollo client so we dont need to explicitly pass it
  });

  const head = createHead();

  hydrateRoot(
    document.getElementById('app')!,
    <BrowserRouter>
      <MelwaysClientProvider siteName={site} environment={environment}>
        <HubbleClientProvider appConfig={config}>
          <UnheadProvider head={head}>
            <App apolloClient={apolloClient} config={config} />
          </UnheadProvider>
        </HubbleClientProvider>
      </MelwaysClientProvider>
    </BrowserRouter>,
  );
});
